<p-floatlabel>
    <p-autocomplete #providerAutocomplete
        [(ngModel)]="selectedProvider" 
        [suggestions]="providers"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="MinAutocompleteCharsToSearch"
        (completeMethod)="loadProviders($event)"
        (onSelect)="onChangeSelectedProvider()"
        (onClear)="onChangeSelectedProvider()"
        optionLabel="name"
        [disabled]="isDisabled"
        [emptyMessage]="l('::NoData')"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.name }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="providerAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{ labelToShow }}
        </app-label-content>
    </label>
</p-floatlabel>